module.exports = __webpack_public_path__ + "img/icon-audio.e79679d3.png";